import { clsx } from "clsx";

type SecondaryCTAProps = React.ComponentPropsWithoutRef<"button">;

export function SecondaryCTA({
  children,
  onClick,
  className = "",
  ...props
}: SecondaryCTAProps) {
  return (
    <button
      className={clsx(
        "inline-flex cursor-pointer items-center justify-center rounded-md border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-all hover:bg-gray-50 hover:shadow-lg",
        className,
      )}
      onClick={onClick}
      {...props}
    >
      <span>{children}</span>
    </button>
  );
}
